import {FormControlLabel, Radio} from '@mui/material';
import {bool, number, oneOfType, shape, string} from 'prop-types';

const CustomRadio = ({checked, value, label, sx = {}, size = 'small', ...rest}) => {
  return (
    <FormControlLabel
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: 14
        },
        ...sx
      }}
      value={value}
      control={<Radio size={size} checked={checked} />}
      label={label}
      {...rest}
    />
  );
};

CustomRadio.propTypes = {
  checked: bool.isRequired,
  label: string.isRequired,
  size: string,
  sx: shape({}),
  value: oneOfType([string, number, bool]).isRequired
};

export default CustomRadio;
